import { FC } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

import { InsightReasonDetails } from '../../../../api/types/ShadowAdminInsightReason';
import CopyButton from '../CopyButton';
import { SHADOW_ADMIN_ENTITY_TYPES_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { SHADOW_ADMINS_ENTITIES_EXTERNAL_TYPES } from '@silverfort-nodelibs/common/utils/consts';

interface Props {
    loading: boolean;
    reasons?: InsightReasonDetails[];
    reasonsStr?: string;
}

const getPermissionStr = (permissions) => {
    let permissionsStr = ``;
    if (permissions.length) {
        permissionsStr = `has the following ${permissions.length === 1 ? 'permission' : 'permissions'}: ${permissions
            .map((permission) => `'${permission}'`)
            .join(', ')} over `;
    }
    return permissionsStr;
};

// ts ported original explainability function
const getReasonDisplay = (reason) => {
    const reasonRaws: JSX.Element[] = [];
    const vowelRegex = /^[aeiouAEIOU]/; // Regular expression to check if the first character is a vowel (case-insensitive)
    for (let i = 0; i < reason.length - 1; i++) {
        const entity = reason[i];
        const nextEntity = reason[i + 1];

        if (nextEntity.permissions.length) {
            const permissionsStr = nextEntity ? getPermissionStr(nextEntity.permissions) : '';
            reasonRaws.push(
                <div key={`${i}-permission`}>
                    <span>{SHADOW_ADMIN_ENTITY_TYPES_NAMES[entity.type]}</span>
                    &nbsp;
                    <span className="font-bold">{entity.name}</span>
                    &nbsp;<span>{permissionsStr}</span>
                    {nextEntity.type !== SHADOW_ADMINS_ENTITIES_EXTERNAL_TYPES.UNDEFINED ? (
                        <span>{SHADOW_ADMIN_ENTITY_TYPES_NAMES[nextEntity.type]}</span>
                    ) : (
                        <span>{vowelRegex.test(nextEntity.name) ? 'an' : 'a'}</span>
                    )}
                    &nbsp;
                    <span className="font-bold">{nextEntity.name}.</span>
                </div>
            );
        }
        if (nextEntity.memberOf) {
            reasonRaws.push(
                <div key={`${i}-memberOf`}>
                    <span>{SHADOW_ADMIN_ENTITY_TYPES_NAMES[entity.type]}</span>
                    &nbsp;
                    <span className="font-bold">{entity.name}</span>
                    &nbsp;
                    <span>is a member of</span>
                    &nbsp;
                    <span>{SHADOW_ADMIN_ENTITY_TYPES_NAMES[nextEntity.type]}</span>
                    &nbsp;
                    <span className="font-bold">{nextEntity.name}.</span>
                </div>
            );
        }
    }
    return reasonRaws;
};

const ShadowAdminReasonsContent: FC<Props> = ({ loading, reasons, reasonsStr }) => {
    return (
        <div className="w-full h-full flex flex-col gap-3 relative overflow-y-auto">
            {reasonsStr && (
                <div className="absolute right-2 top-2">
                    <CopyButton copyContent={reasonsStr} />
                </div>
            )}
            {loading ? (
                <div className="h-fit w-fit self-center justify-self-center">
                    <CircularProgress />
                </div>
            ) : reasons?.length ? (
                reasons.map((reason, index) => (
                    <div className="flex w-4/5 font-sf text-12 text-sf-gray-500 whitespace-normal" key={index}>
                        <div className="pr-2">{index + 1}.</div>
                        <div>{getReasonDisplay(reason)}</div>
                    </div>
                ))
            ) : (
                'No reasons found'
            )}
        </div>
    );
};

export default ShadowAdminReasonsContent;
